<template>
  <v-row>
    <v-col cols="12" lg="3">
      <v-chip class="error orders__title">
        <span class="white--text font-bold">
          {{ $t("user_details") }}
        </span>
      </v-chip>
    </v-col>
    <v-col cols="12">
      <v-card flat class="orders__invoice">
        <v-container>
          <v-row>
            <v-col cols="12" lg="6">
              <div class="d-flex align-center">
                <span class="px-2">
                  {{ $t("Name") }}
                </span>
                <span class="primary--text font-bold">
                  {{ userDetails.firstname + " " + userDetails.lastname }}
                </span>
              </div>
            </v-col>
            <v-col cols="12" lg="6">
              <div class="d-flex align-center">
                <span class="px-2">
                  {{ $t("email") }}
                </span>
                <span class="primary--text font-bold">
                  {{ userDetails.email }}
                </span>
              </div>
            </v-col>
            <v-col cols="12" lg="6">
              <div class="d-flex align-center">
                <span class="px-2">
                  {{ $t("Phone") }}
                </span>
                <span class="primary--text font-bold">
                 {{
                    userDetails.phone.country_code +
                      " " +
                      userDetails.phone.number
                  }}
                </span>
              </div>
            </v-col>
                 <v-col cols="12" lg="6">
              <div class="d-flex align-center">
                <span class="px-2">
                  {{ $t("country") }}
                </span>
                <span class="primary--text font-bold">
                 {{
                    userDetails.country.name
                  }}
                </span>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    userDetails: {
      type: Object,
      default: () => {}
    }
  }
};
</script>
